import Vue from 'vue';
import snq from 'snq';
import store from '@/store';

export const smoothScroll = (item) => {
  let scrollWrapper;
  const sportsHeader = snq(() => document.querySelector('.sports-header').getBoundingClientRect().height, 0);
  const headerOffset = snq(() => document.querySelector('.main-header').getBoundingClientRect().height, 0);
  const elementPosition = item.getBoundingClientRect().top;
  const offsetPosition = elementPosition - headerOffset - sportsHeader;

  if (Vue.prototype.$isElectron) {
    scrollWrapper = document.querySelector('.line-center-wrapper');
  } else {
    scrollWrapper = window;
  }
  scrollWrapper.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
};
export const addClass = (item) => {
  item.classList.add('highlighted');
  setTimeout(() => {
    item.classList.remove('highlighted');
  }, 3000);
};

export const scrollToLineItem = (toScrollItem) => {
  const { id, type } = toScrollItem;
  if (type === 'game') {
    setTimeout(() => {
      const item = document.getElementById(`game-${id}`);
      smoothScroll(item);
      addClass(item);
      store.commit(
        'betLines/setToScrollItem',
        {
          id: null,
          type: null,
        },
        { root: true },
      );
    }, 2000);
  }
};

export const findNode = (nodes, predicate) => {
  for (const node of nodes) {
    if (predicate(node)) return node;

    if (node.children) {
      let match = findNode(node.children, predicate);
      if (match) return match;
    }
  }
};
export const findParent = (child) => {
  let foundItem = null;
  const menuList = snq(() => store.state.sportMenu.menuList, []);
  const allLive = menuList.find((item) => item.icon === 'live');
  snq(() => allLive.children[0].children, []).forEach((item) => {
    item.children.forEach((item2) => {
      if (item2 && child && item2.id === child.id) {
        foundItem = item;
      }
    });
  });
  return foundItem;
};
export const getIconFromMenuForLive = (league_id) => {
  const menuList = snq(() => store.state.sportMenu.menuList, []);
  const targetMenu = findNode(menuList || [], (item) => item.league_id == league_id);
  const parent = findParent(targetMenu);
  return parent && parent.icon;
};
export const getMenuByLeagueId = (league_id, isLive) => {
  let menuList;
  // TournamentIds is the same preMatch & LiveMatch
  if (isLive) {
    menuList = snq(() => store.state.sportMenu.menuList.filter(menu => menu.icon !== 'all-sport'), []);
  }
  else menuList = snq(() => store.state.sportMenu.menuList.filter(menu => menu.icon !== 'live'), []);

  const targetMenu = findNode(menuList || [], item => item.league_id == league_id);
  return targetMenu;
};

export const compareMarkets = (list) => {
  function compareMarkets(a, b) {
    if (a.orderNumber < b.orderNumber) return 1;
    else if (a.orderNumber > b.orderNumber) return -1;
    else return 1;
  }
  return list.sort(compareMarkets);
}

